import styled from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";

const { color, radius, typeScale } = adminTokens;
const [, spaceSm] = adminTokens.spacing;

// The "Admin" tag beside the brand: Medium 11 capitals in a sage pill (SHELL-R3).
export const AdminTag = styled.span`
  flex: none;
  padding: 2px ${spaceSm}px;
  border-radius: ${radius.pill}px;
  background-color: ${color.sage};
  font-family: ${typeScale.labelValue.fontFamily};
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;
